import { hideVideo } from './hideVideo';
import { togglePlaying } from './togglePlaying';

/**
 * Sets up the close button event handler to stop the video and hide it when clicked.
 * This provides a way for users to close the video player and stop playback.
 * @param {HTMLVideoElement} videoElement - The video element to stop and hide.
 * @param {object} dashPlayer - The Dash player instance to control playback.
 */
export function setupControls(videoElement) {
  const closeButton = document.getElementById('closeButton');
  closeButton.style.display = 'none';
  closeButton.addEventListener('click', () => {
    if (!videoElement.parentNode) return;
    if (videoElement.style.display==="none") {
      return;
    }
    videoElement.pause();
    hideVideo(videoElement);
  });

  const fullScreenButton = document.getElementById("fullscreenBtn");
  fullScreenButton.addEventListener('click', () => {
    if (!videoElement.parentNode) return;
    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
      videoElement.setAttribute("controls","true");
    } else if (videoElement.webkitRequestFullscreen) {
      videoElement.webkitRequestFullscreen();
      videoElement.setAttribute("controls","true");
    } else if (videoElement.webkitEnterFullscreen) {
      setTimeout(() => {
        videoElement.webkitEnterFullscreen(); // Only works on iOS
      }, 250);
    }
  });
  document.addEventListener("fullscreenchange", ()=> {
    console.log("fullscreenchange", document.fullscreenElement)
    if (!document.fullscreenElement) {
      videoElement.removeAttribute("controls");
    }
  });

  const iconMute = document.getElementById('iconMute');
  const muteButton = document.getElementById('muteBtn');
  iconMute.className = "icon-mute-off";
  muteButton.addEventListener('click', () => {
    if (!videoElement.parentNode) return;
    if (videoElement.style.display==="none") {
      return;
    }
    if (videoElement.muted) {
      videoElement.muted = false;
      iconMute.className = "icon-mute-off";
    } else {
      videoElement.muted = true;
      iconMute.className = "icon-mute-on";
    }
  });

  const iconPlayPause = document.getElementById('iconPlayPause');
  iconPlayPause.className = "icon-play";
  const playPauseBtn = document.getElementById('playPauseBtn');
  playPauseBtn.addEventListener('click', () => {
    if (!videoElement.parentNode) return;
    togglePlaying(videoElement);
  });
}
